import { render, staticRenderFns } from "./CustomersView.vue?vue&type=template&id=61ea1a17"
import script from "./CustomersView.vue?vue&type=script&lang=js"
export * from "./CustomersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports